import type { FaireProductEntity } from "../../entity_types/product";

export const p_t396g9xcye: FaireProductEntity = {
  token: "p_t396g9xcye",
  type: "product",
  name: "Bauhaus Short Sleeve Sweater Tee - Cumulus",
  brandToken: "b_9ut9ansxk1",
  brandName: "The Endery",
  imageUrl: "https://cdn.faire.com/fastly/35734783c968499ddebef292ef127f17e2540b78ff4f9f8aa506a8238e0d16a2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2fb490f84f64184643124e24d49011cbe42799109bcf72aab0772daeb3b19725.jpeg",
    "https://cdn.faire.com/fastly/67d61b4f8022b292e92221fd9f660984bcea24857dc81c396dd88b1f9cc20eb5.jpeg",
    "https://cdn.faire.com/fastly/0b8163bb212a5f354e06d5864b4548905916691d076dba224544abf465ed806b.jpeg",
    "https://cdn.faire.com/fastly/1a9ef74de9b8afbd0c314f9c0a20da3103779e947e0bcffa46fb65721730ea16.jpeg",
    "https://cdn.faire.com/fastly/75cccf3ad1df6f045ecf14f5bbab84a70be01b2d7a0197c641fdba8d3e87db5e.jpeg",
    "https://cdn.faire.com/fastly/e45fbea7a08b1cd98047cbd8acb76bc8c3b6899a78c05d68cb2c070b0a06c47a.jpeg",
    "https://cdn.faire.com/fastly/6cd5c4648b34208c6edd86a1cd25e6435bc3be0bb096021efdb36cb044160997.jpeg",
    "https://cdn.faire.com/fastly/fec01ada6fc5a8cb5978952da4788b14d347011d4adf101f7a8c1e17cd8532ec.jpeg",
    "https://cdn.faire.com/fastly/0104ef01644d6459343e2a7f945fcb5c6b64922dafa6e534b79914cdc9f2bfff.jpeg"
  ],
  priceDollars: 75.6,
  description: "Our signature Bauhaus Tee, built on a bold jacquard grid — the pattern is knitted in, never printed on top. Lightweight, breathable, and easy to style.\n\n * Slightly cropped and boxy body \n * 100% Pima cotton \n * Made in Lima, Peru, with knitwear specialists we have worked with for years — Fair Trade certified ",
  tags: [],
  msrpDollars: 168,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-13T05:50:26.335Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
